/* =============================================================================
   TINCTURESCU — T3K home.js
   Home-page behaviour that is not covered by the app.js primitives:
   - Ritual builder ([data-ritual]): selection -> live count / total / savings,
     builds the data-cart-add-multi payload, adds through T3K.cart.add() and
     opens the drawer with T3K.cart.open().
   Loaded with `defer` by the sections that need it (guarded: runs once even if
   the file is included twice). Idempotent per element (data-home-inited).
   ============================================================================= */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.__t3kHome) return;
  W.__t3kHome = true;

  function qs(sel, ctx) { return (ctx || D).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || D).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el && el.addEventListener) el.addEventListener(ev, fn, opts || false); }
  function T() { return W.T3K || {}; }

  /* Money: use T3K.money when app.js is ready, else a small local formatter
     that understands the store's money_format ("99,00 lei"). */
  function money(cents) {
    var t = T();
    if (typeof t.money === 'function') return t.money(cents);
    var fmt = String(t.moneyFormat || '{{amount_with_comma_separator}} lei').replace(/<[^>]*>/g, '');
    var n = Math.abs(Number(cents) || 0) / 100;
    var comma = /comma_separator|space_separator/.test(fmt);
    var v = n.toFixed(2);
    if (comma) v = v.replace('.', ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).trim();
  }
  function toast(text, kind) {
    var t = T();
    if (typeof t.toast === 'function') t.toast(text, kind);
  }
  function plural(n, one, many) { return n === 1 ? one : many; }

  /* ---------------------------------------------------------------------------
     RITUAL BUILDER
     --------------------------------------------------------------------------- */
  function initRitual(root) {
    if (root.getAttribute('data-home-inited')) return;
    root.setAttribute('data-home-inited', '1');

    var max = Math.max(1, parseInt(root.getAttribute('data-max') || '3', 10) || 3);
    var tier2 = parseFloat(root.getAttribute('data-tier2')) || 0;
    var tier3 = parseFloat(root.getAttribute('data-tier3')) || 0;
    var inputs = qsa('input[data-ritual-item]', root);
    var btn = qs('[data-ritual-add]', root);
    var bar = qs('[data-ritual-bar]', root);
    var countEl = qs('[data-ritual-count]', root);
    var totalEl = qs('[data-ritual-total]', root);
    var oldEl = qs('[data-ritual-old]', root);
    var saveWrap = qs('[data-ritual-save-wrap]', root);
    var saveEl = qs('[data-ritual-save]', root);
    var hintEl = qs('[data-ritual-hint]', root);
    var tiers = qsa('[data-tier]', root);
    if (!inputs.length || !btn) return;

    function selected() { return inputs.filter(function (i) { return i.checked; }); }
    function pctFor(n) { return n >= 3 ? tier3 : n === 2 ? tier2 : 0; }

    function hintFor(n, pct) {
      if (n === 0) return 'Alege ' + (max >= 2 ? 'două sau trei sticle' : 'o sticlă') + ' și vezi reducerea pe loc.';
      if (n === 1 && tier2 > 0) return 'Încă o sticlă și primești <strong>' + tier2 + '%</strong> reducere.';
      if (n === 2 && tier3 > 0 && max >= 3) return 'Încă una și reducerea urcă la <strong>' + tier3 + '%</strong>.';
      if (pct > 0) return 'Reducere maximă activată: <strong>' + pct + '%</strong>. Se aplică automat în coș.';
      return 'Reducerea se aplică automat în coș.';
    }

    function update() {
      var sel = selected();
      var n = sel.length;
      var total = 0;
      sel.forEach(function (i) { total += parseInt(i.getAttribute('data-price') || '0', 10) || 0; });
      var pct = pctFor(n);
      var save = Math.round(total * pct / 100);
      var items = sel.map(function (i) { return { id: parseInt(i.value, 10), quantity: 1 }; })
        .filter(function (it) { return it.id > 0; });

      if (countEl) countEl.textContent = n + ' din ' + max;
      if (totalEl) totalEl.textContent = money(total - save);
      if (oldEl) { oldEl.textContent = money(total); oldEl.hidden = save <= 0; }
      if (saveEl) saveEl.textContent = money(save);
      if (saveWrap) saveWrap.hidden = save <= 0;
      if (hintEl) hintEl.innerHTML = hintFor(n, pct);

      btn.disabled = items.length === 0;
      btn.setAttribute('aria-disabled', items.length === 0 ? 'true' : 'false');
      btn.setAttribute('data-cart-add-multi', JSON.stringify(items));
      var label = qs('[data-ritual-btn-label]', btn);
      if (label) {
        label.textContent = n > 0
          ? 'Adaugă ritualul în coș (' + n + ' ' + plural(n, 'sticlă', 'sticle') + ')'
          : 'Adaugă ritualul în coș';
      }
      if (bar) bar.classList.toggle('is-active', n > 0);

      inputs.forEach(function (i) {
        var tile = i.closest('.tile');
        var full = !i.checked && n >= max;
        if (tile) {
          tile.classList.toggle('is-selected', i.checked);
          tile.classList.toggle('is-disabled', full);
        }
        i.setAttribute('aria-disabled', full ? 'true' : 'false');
      });
      var activeTier = n >= 3 ? 3 : n;
      tiers.forEach(function (ch) {
        ch.classList.toggle('is-active', parseInt(ch.getAttribute('data-tier'), 10) === activeTier);
      });
      root.setAttribute('data-ritual-count', String(n));
    }

    inputs.forEach(function (i) {
      on(i, 'change', function () {
        if (i.checked && selected().length > max) {
          i.checked = false;
          toast('Poți alege cel mult ' + max + ' ' + plural(max, 'sticlă', 'sticle') + '. Scoate una ca să adaugi alta.', 'info');
        }
        update();
      });
      /* Space/Enter on the label focus target (checkbox is visually hidden). */
      on(i, 'keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); i.click(); }
      });
    });

    on(btn, 'click', function (e) {
      e.preventDefault();
      e.stopPropagation(); /* app.js also listens for [data-cart-add-multi]; we handle it here */
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      var items = [];
      try { items = JSON.parse(btn.getAttribute('data-cart-add-multi') || '[]'); } catch (err) { items = []; }
      if (!items.length) { toast('Alege produsele mai întâi.', 'info'); return; }
      var t = T();
      if (!t.cart || typeof t.cart.add !== 'function') {
        /* app.js not ready: fall back to a plain cart form post */
        var f = qs('form[data-ritual-fallback]', root);
        if (f) {
          f.innerHTML = items.map(function (it) {
            return '<input type="hidden" name="items[][id]" value="' + it.id + '"><input type="hidden" name="items[][quantity]" value="' + it.quantity + '">';
          }).join('');
          f.submit();
        }
        return;
      }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      t.cart.add(items)
        .then(function () {
          /* the drawer opening is the confirmation (a toast would cover its heading) */
          btn.classList.add('is-success');
          setTimeout(function () { btn.classList.remove('is-success'); }, 1400);
          t.cart.open();
        })
        .catch(function (err) {
          var msg = 'Nu am putut adăuga produsele. Încearcă din nou.';
          if (typeof t.cart.errorText === 'function') msg = t.cart.errorText(err);
          if (typeof t.cart.isPartialAdd === 'function' && t.cart.isPartialAdd(err)) {
            return t.cart.refresh().catch(function () { /* noop */ }).then(function () { toast(msg, 'info'); t.cart.open(); });
          }
          toast(msg, 'error');
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    });

    root._t3kRitualUpdate = update;
    update();
  }

  function initAll(scope) {
    var r = scope && scope.nodeType ? scope : D;
    var list = qsa('[data-ritual]', r);
    if (r !== D && r.matches && r.matches('[data-ritual]')) list.unshift(r);
    list.forEach(initRitual);
  }
  function refreshAll() {
    qsa('[data-ritual]').forEach(function (el) { if (el._t3kRitualUpdate) el._t3kRitualUpdate(); });
  }

  function boot() { initAll(D); }
  if (D.readyState === 'loading') on(D, 'DOMContentLoaded', boot); else boot();
  on(D, 'shopify:section:load', function (e) { initAll(e.target); });
  on(D, 't3k:init', function (e) { initAll(e.detail && e.detail.scope); });
  /* app.js became ready after us: re-render money with the real formatter */
  on(D, 't3k:ready', refreshAll);
})();
